import { render, staticRenderFns } from "./ReasonSelection.vue?vue&type=template&id=321e15aa&"
import script from "./ReasonSelection.vue?vue&type=script&lang=js&"
export * from "./ReasonSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports